import * as types from '../mutation-types'
import { api } from '@/modules/api/index'

export const state = {
  packages: [],
  predefinedActivity: [],
  totalPredefinedActivityPages: 0,
  totalPredefinedActivityItems: 0,
  killerFeatureData: {}
}

export const getters = {
  packagesList: state => state.packages,
  predefinedActivity: state => state.predefinedActivity,
  totalPredefinedActivityPages: state => state.totalPredefinedActivityPages,
  totalPredefinedActivityItems: state => state.totalPredefinedActivityItems
}

export const actions = {
  async getPackagesList ({ commit }, filterParams) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.packages.getPackagesList(filterParams))
      // commit(types.CREATE_SUCCESS_MESSAGE, 'Packages was uploaded successfully')
      commit(types.SET_PACKAGE_LIST, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Packages wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async addPackageList ({ commit }, newPackage) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.post(api.packages.addPackageList(), newPackage)
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Packages weren\'t added')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editPackageList ({ commit }, editPackage) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.put(api.packages.editPackageList(), { ...editPackage })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Packages was edited successfully')
      return response
    } catch (err) {
      if (err.response.data.Code === 'fm.cms-0100') {
        commit(types.CREATE_ERROR_MESSAGE, 'Packages weren\'t edited. ' + err.response.data.Message)
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Packages weren\'t edited')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deletePackageList ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios({ method: 'delete', url: api.packages.deletePackageList(id) })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Packages was deleted successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Packages wasn\'t deleted')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async getPredefinedActivity ({ commit }, conf) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.predefinedActivity.getPredefinedActivity(conf))
      // commit(types.CREATE_SUCCESS_MESSAGE, 'Packages was uploaded successfully')
      commit(types.SET_PREDEFINED_ACTIVITY, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Packages wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async addPredefinedActivity ({ commit }, newPredefinedActivity) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = this.$axios.post(api.predefinedActivity.addPredefinedActivity(), newPredefinedActivity)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Packages was added successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Packages wasn\'t added')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editPredefinedActivity ({ commit }, editPredefinedActivity) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.put(api.predefinedActivity.editPredefinedActivity(), { ...editPredefinedActivity })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Packages was edited successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Packages wasn\'t edited')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deletePredefinedActivity ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios({
        method: 'delete',
        url: api.predefinedActivity.deletePredefinedActivity(id)
      })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Packages was deleted successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Packages wasn\'t deleted')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editKillerFeatureData ({ commit }, newSettings) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.put(api.packages.editKillerFeatureData(), newSettings)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Data was successfully updated')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Data wasn\'t added')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

export const mutations = {
  [types.SET_PACKAGE_LIST] (state, { packages }) {
    state.packages = [...packages]
  },
  [types.SET_PREDEFINED_ACTIVITY] (state, { predefinedActivities, totalPages, totalItems }) {
    state.predefinedActivity = [...predefinedActivities]
    state.totalPredefinedActivityPages = totalPages
    state.totalPredefinedActivityItems = totalItems
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/packages.js